import API from '../api-service';

const baseUri = 'authentication';

export default {
  getAuthentications(params) {
    return API.get(baseUri, params);
  },
  getSAML2AuthenticationLink(params) {
    return API.get(`${baseUri}/saml2-link`, params);
  },
  authenticated(contentCode) {
    const sessionId = localStorage.getItem('session');

    if (!sessionId) {
      return false;
    }
    return API.get(`${baseUri}/authenticated`, { sessionId, contentCode });
  },
};
